module.exports = __webpack_public_path__ + "static/class-notes-thumb-e47381383ef700c7a973994ce9df4f00.jpg";